import React from 'react';
import {useTranslation} from 'react-i18next';
import Datepicker from 'react-tailwindcss-datepicker';
import SelectComponent from '../../../Selects/SelectComponent';

// import { Container } from './styles';

function FiltrosContaCorrente({info}) {
    const {
        filtroSociedade,
        setFiltroSociedade,
        filtroEstab,
        setFiltroEstab,
        filtroEndereco,
        setFiltroEndereco,
        filtroDtFatura,
        setFiltroDtFatura,
        filtroDtVencimento,
        setFiltroDtVencimento,
        filtroRep,
        setFiltroRep,
        filtroValor,
        setFiltroValor,
        filtroValorPendente,
        setFiltroValorPendente,
        filtroNumDoc,
        setFiltroNumDoc,
        filtroDivisa,
        setFiltroDivisa,
        representantes,
        setRepresentantes,
        estabelecimentos,
        setEstabelecimentos,
        divisas,
        setDivisas,
    } = info;

    const {t} = useTranslation();
    return (
        <div>
            <div className=" mt-2">
                <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                    {t('sociedade')}
                </label>
                <div className="relative mt-2">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroSociedade}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroSociedade(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className=" mt-2">
                <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                    {t('endereco')}
                </label>
                <div className="relative mt-2">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroEndereco}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroEndereco(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className=" mt-2">
                <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                    {t('valor')}
                </label>
                <div className="relative mt-2">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroValor}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroValor(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className=" mt-2">
                <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                    {t('nDoc')}
                </label>
                <div className="relative mt-2">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroNumDoc}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroNumDoc(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className=" mt-2">
                <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                    {t('valorPendente')}
                </label>
                <div className="relative mt-2">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroValorPendente}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroValorPendente(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('representante')}
                </label>
                <SelectComponent
                    options={representantes}
                    value={filtroRep ? filtroRep.label : ''}
                    onChange={e => {
                        setFiltroRep(e.label);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('filtro')}
                />
            </div>
            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('estabelecimento')}
                </label>
                <SelectComponent
                    options={estabelecimentos}
                    value={filtroEstab ? filtroEstab.label : ''}
                    onChange={e => {
                        setFiltroEstab(e.label);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('filtro')}
                />
            </div>
            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('divisa')}
                </label>
                <SelectComponent
                    options={divisas}
                    value={filtroDivisa ? filtroDivisa.label : ''}
                    onChange={e => {
                        setFiltroDivisa(e.label);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('filtro')}
                />
            </div>
            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('dataFatura')}
                </label>
                <Datepicker
                    displayFormat="DD/MM/YYYY"
                    useRange={false}
                    asSingle={true}
                    value={filtroDtFatura}
                    onChange={newValue => {
                        setFiltroDtFatura(newValue);
                    }}
                    inputClassName={`rounded-[8px] mt-2 w-full bg-gray-50 border border-gray-300 text-lg text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                />
            </div>
            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('dataVenc')}
                </label>
                <Datepicker
                    displayFormat="DD/MM/YYYY"
                    // maxDate={today}
                    useRange={false}
                    asSingle={true}
                    value={filtroDtVencimento}
                    onChange={newValue => {
                        setFiltroDtVencimento(newValue);
                    }}
                    inputClassName={`rounded-[8px] mt-2 w-full mb-4 bg-gray-50 border border-gray-300 text-lg text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                />
            </div>
        </div>
    );
}

export default FiltrosContaCorrente;
